import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo6Act8 from "../../../DnD/modulo6Act8";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 8.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[7];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo6.content[0].activities[8].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[8].path}`,
    titlePrev: `${modulo6.content[0].activities[6].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };
  const items = [
    <div className="selectable btn btn-blue shadow mx-3 my-1">
      Micaela Bastidas
    </div>,

    <div className="selectable btn btn-blue shadow mx-3 my-1">
      Simón Bolívar
    </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">José Olaya</div>,

    <div className="selectable btn btn-blue shadow mx-3 my-1">Túpac Amaru</div>,

    <div className="selectable btn btn-blue shadow mx-3 my-1">
      José de San Martín
    </div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">
      María Parado de Bellido
    </div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          A continuación aparecen diversos hombres y mujeres que lucharon por la
          independencia del Perú.
        </li>
        <li>
          Coloca el nombre que corresponda en el espacio debajo de cada
          personaje.{" "}
        </li>
        <li>
          Ahora escoge uno de estos personajes y busca información sobre él o
          ella. Luego comparte lo que hayas encontrado con un compañero,
          compañera o familiar.
        </li>
      </ul>

      <Modulo6Act8 items={items} />

      <GuiaDocente>
        <p>
          Lea las indicaciones. Conversen sobre a quiénes reconocen. Ayude a
          reconocer a los personajes y dé alguna información respecto de su
          contribución a la independencia. Los personajes son Túpac Amaru, Simón
          Bolívar, María Parado de Bellido, José de San Martín, Micaela Bastidas
          y José Olaya.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
